import { render } from "./index.vue?vue&type=template&id=124b58ad&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=124b58ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-124b58ad"

export default script